import { Box, Divider, Typography } from '@mui/material';
import { pdfContainerSx } from './PdfSxs';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { formatToUSCurrency, parseAsLocalDate, timeConverter } from '../config/FunctionHelper';
import { cardsCss, newCardsCss } from 'src/content/dashboard/DashboardCss';

export const PdfGraphDetailBox = ({
  isPdfBuilder,
  reportMetaData
}: {
  isPdfBuilder?: boolean;
  reportMetaData?: any;
}) => {
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  const timeline = (pdfReportData as any)?.config?.timeline;

  const graphData = pdfReportData?.graphDetails;
  const aiVisibilityData = pdfReportData?.aiVisibilityDetails;

  const getGscGraphDetails = {
    totalsGraphDetails: {
      totalClicks: graphData?.totalMetrics?.totalClicks,
      totalImpressions: graphData?.totalMetrics?.totalImpressions,
      averageCtr: graphData?.totalMetrics?.averageCtr,
      averagePosition: graphData?.totalMetrics?.averagePosition
    },
    comparisonMetrics: {
      clicksChange: graphData?.totalMetrics?.clicksDifference,
      impressionsChange: graphData?.totalMetrics?.impressionsDifference,
      ctrChange: graphData?.totalMetrics?.ctrDifference,
      positionChange: graphData?.totalMetrics?.posDifference
    },
    previousStart: graphData?.totalMetrics?.previousStart,
    previousEnd: graphData?.totalMetrics?.previousEnd
  };

  const getOrganicSearchTrafficDetails = {
    compareStartDate: (timeline?.periodStartDate || 0) * 1000,
    compareEndDate: (timeline?.periodEndDate || 0) * 1000
  };

  let compareDate =
    useSelector((state: RootState) => state.siteAudit?.compareDate) ?? 0;
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );

  const aiProgressValue = Math.round(
    aiVisibilityData?.mainVisibilityScore || 0
  );
  const isShowAiData = !!aiVisibilityData;
  return (
    <>
      <Box
        sx={{
          ...pdfContainerSx?.pdfCardsSx,
          //maxWidth: { xs: '1337px' }
          width: 'Fixed (1,140px)',
          minHeight: '100px'
        }}
      >
        <div style={pdfContainerSx?.graphDetailBoxSx}>
          <div style={pdfContainerSx?.graphTabBoxSx}>
            <div className="w-full">
              <p
                style={{
                  ...pdfContainerSx?.graphTitleTextSx,
                  textAlign: 'center'
                }}
              >
                {'Total Clicks'}
              </p>
              <div style={pdfContainerSx?.graphValueBoxSx}>
                <p style={pdfContainerSx?.graphValueSx}>
                  {formatToUSCurrency(
                    getGscGraphDetails?.totalsGraphDetails?.totalClicks
                  ) || '-'}
                </p>
                {getGscGraphDetails?.comparisonMetrics?.clicksChange && (
                  <Box sx={newCardsCss?.newIconBoxCss}>
                    {parseFloat(
                      getGscGraphDetails?.comparisonMetrics?.clicksChange || 0
                    ) < 0 ? (
                      <>
                        {/*<TrendingDownIcon sx={newCardsCss?.trendingDownIconSx} />*/}
                        <img
                          src="/static/images/icons/red_down.svg"
                          alt="icon"
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            ...newCardsCss?.perNewSx
                          }}
                        >
                          {getGscGraphDetails?.comparisonMetrics
                            ?.clicksChange != null
                            ? `${getGscGraphDetails?.comparisonMetrics?.clicksChange}%`
                            : ''}
                        </Typography>
                      </>
                    ) : getGscGraphDetails?.comparisonMetrics?.clicksChange ? (
                      <>
                        <div
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            height: 'auto'
                          }}
                        >
                          <img
                            src="/static/images/icons/green_up.svg"
                            alt="icon"
                            style={
                              {
                                //objectFit: 'contain'
                              }
                            }
                            //style={newCardsCss?.imgSx}
                          />
                        </div>
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            fontSize: '16px'
                          }}
                        >
                          {parseFloat(
                            getGscGraphDetails?.comparisonMetrics?.clicksChange
                          )}
                          %
                        </Typography>
                      </>
                    ) : (
                      <>
                        {/*<Typography sx={newCardsCss?.noChangesSx}>
                        {cardsTexts?.noChanges}
                      </Typography>*/}
                      </>
                    )}
                  </Box>
                )}
              </div>
            </div>
            <div>
              <Divider
                sx={pdfContainerSx?.dividerGraphSx}
                orientation="vertical"
              />
            </div>
          </div>
          <div style={pdfContainerSx?.graphTabBoxSx}>
            <div className="w-full">
              <p
                style={{
                  ...pdfContainerSx?.graphTitleTextSx,
                  textAlign: 'center'
                }}
              >
                {'Total Impressions'}
              </p>
              <div style={pdfContainerSx?.graphValueBoxSx}>
                <p style={pdfContainerSx?.graphValueSx}>
                  {formatToUSCurrency(
                    getGscGraphDetails?.totalsGraphDetails?.totalImpressions
                  ) || '-'}
                </p>
                {getGscGraphDetails?.comparisonMetrics?.impressionsChange && (
                  <Box sx={newCardsCss?.newIconBoxCss}>
                    {parseFloat(
                      getGscGraphDetails?.comparisonMetrics
                        ?.impressionsChange || 0
                    ) < 0 ? (
                      <>
                        {/*<TrendingDownIcon sx={newCardsCss?.trendingDownIconSx} />*/}
                        <img
                          src="/static/images/icons/red_down.svg"
                          alt="icon"
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            ...newCardsCss?.perNewSx
                          }}
                        >
                          {getGscGraphDetails?.comparisonMetrics
                            ?.impressionsChange != null
                            ? `${getGscGraphDetails?.comparisonMetrics?.impressionsChange}%`
                            : ''}
                        </Typography>
                      </>
                    ) : getGscGraphDetails?.comparisonMetrics
                        ?.impressionsChange ? (
                      <>
                        <div
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            height: 'auto'
                          }}
                        >
                          <img
                            src="/static/images/icons/green_up.svg"
                            alt="icon"
                            style={
                              {
                                //objectFit: 'contain'
                              }
                            }
                            //style={newCardsCss?.imgSx}
                          />
                        </div>
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            fontSize: '16px'
                          }}
                        >
                          {parseFloat(
                            getGscGraphDetails?.comparisonMetrics
                              ?.impressionsChange
                          )}
                          %
                        </Typography>
                      </>
                    ) : (
                      <>
                        {/*<Typography sx={newCardsCss?.noChangesSx}>
                        {cardsTexts?.noChanges}
                      </Typography>*/}
                      </>
                    )}
                  </Box>
                )}
              </div>
            </div>
            <div>
              <Divider
                sx={pdfContainerSx?.dividerGraphSx}
                orientation="vertical"
              />
            </div>
          </div>
          <div style={pdfContainerSx?.graphTabBoxSx}>
            <div className="w-full">
              <p
                style={{
                  ...pdfContainerSx?.graphTitleTextSx,
                  textAlign: 'center'
                }}
              >
                {'Average CTR'}
              </p>
              <div style={pdfContainerSx?.graphValueBoxSx}>
                <p style={pdfContainerSx?.graphValueSx}>
                  {getGscGraphDetails?.totalsGraphDetails?.averageCtr || '-'}
                  {getGscGraphDetails?.totalsGraphDetails?.averageCtr
                    ? '%'
                    : ''}
                </p>
                {getGscGraphDetails?.comparisonMetrics?.ctrChange && (
                  <Box sx={newCardsCss?.newIconBoxCss}>
                    {parseFloat(
                      getGscGraphDetails?.comparisonMetrics?.ctrChange || 0
                    ) < 0 ? (
                      <>
                        {/*<TrendingDownIcon sx={newCardsCss?.trendingDownIconSx} />*/}
                        <img
                          src="/static/images/icons/red_down.svg"
                          alt="icon"
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            ...newCardsCss?.perNewSx
                          }}
                        >
                          {getGscGraphDetails?.comparisonMetrics?.ctrChange !=
                          null
                            ? `${getGscGraphDetails?.comparisonMetrics?.ctrChange}%`
                            : ''}
                        </Typography>
                      </>
                    ) : getGscGraphDetails?.comparisonMetrics?.ctrChange ? (
                      <>
                        <div
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            height: 'auto'
                          }}
                        >
                          <img
                            src="/static/images/icons/green_up.svg"
                            alt="icon"
                            style={
                              {
                                //objectFit: 'contain'
                              }
                            }
                            //style={newCardsCss?.imgSx}
                          />
                        </div>
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            fontSize: '16px'
                          }}
                        >
                          {parseFloat(
                            getGscGraphDetails?.comparisonMetrics?.ctrChange
                          )}
                          %
                        </Typography>
                      </>
                    ) : (
                      <>
                        {/*<Typography sx={newCardsCss?.noChangesSx}>
                        {cardsTexts?.noChanges}
                      </Typography>*/}
                      </>
                    )}
                  </Box>
                )}
              </div>
            </div>
            <div>
              <Divider
                sx={pdfContainerSx?.dividerGraphSx}
                orientation="vertical"
              />
            </div>
          </div>
          <div style={pdfContainerSx?.graphTabBoxSx}>
            <div className="w-full">
              <p
                style={{
                  ...pdfContainerSx?.graphTitleTextSx,
                  textAlign: 'center'
                }}
              >
                {'Average Position'}
              </p>
              <div style={pdfContainerSx?.graphValueBoxSx}>
                <p style={pdfContainerSx?.graphValueSx}>
                  {getGscGraphDetails?.totalsGraphDetails?.averagePosition ||
                    '-'}
                </p>
                {getGscGraphDetails?.comparisonMetrics?.positionChange && (
                  <Box sx={newCardsCss?.newIconBoxCss}>
                    {parseFloat(
                      getGscGraphDetails?.comparisonMetrics?.positionChange || 0
                    ) < 0 ? (
                      <>
                        {/*<TrendingDownIcon sx={newCardsCss?.trendingDownIconSx} />*/}
                        <img
                          src="/static/images/icons/red_down.svg"
                          alt="icon"
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            ...newCardsCss?.perNewSx
                          }}
                        >
                          {getGscGraphDetails?.comparisonMetrics
                            ?.positionChange != null
                            ? `${getGscGraphDetails?.comparisonMetrics?.positionChange}%`
                            : ''}
                        </Typography>
                      </>
                    ) : getGscGraphDetails?.comparisonMetrics
                        ?.positionChange ? (
                      <>
                        <div
                          style={{
                            ...pdfContainerSx?.commonImgIconStyle,
                            height: 'auto'
                          }}
                        >
                          <img
                            src="/static/images/icons/green_up.svg"
                            alt="icon"
                            style={
                              {
                                //objectFit: 'contain'
                              }
                            }
                            //style={newCardsCss?.imgSx}
                          />
                        </div>
                        <Typography
                          sx={{
                            ...cardsCss?.perSx,
                            fontSize: 'var(--font-size-16)'
                          }}
                        >
                          {parseFloat(
                            getGscGraphDetails?.comparisonMetrics
                              ?.positionChange
                          )}
                          %
                        </Typography>
                      </>
                    ) : (
                      <>
                        {/*<Typography sx={newCardsCss?.noChangesSx}>
                        {cardsTexts?.noChanges}
                      </Typography>*/}
                      </>
                    )}
                  </Box>
                )}
              </div>
            </div>
            <div>
              {isShowAiData && (
                <Divider
                  sx={pdfContainerSx?.dividerGraphSx}
                  orientation="vertical"
                />
              )}
            </div>
          </div>
          {isShowAiData && (
            <div style={pdfContainerSx?.graphTabBoxSx}>
              <div className="w-full">
                <p
                  style={{
                    ...pdfContainerSx?.graphTitleTextSx,
                    textAlign: 'center'
                  }}
                >
                  {'Avg AI Visibility'}
                </p>
                <div style={pdfContainerSx?.graphValueBoxSx}>
                  <p style={pdfContainerSx?.graphValueSx}>
                    {aiProgressValue ? `${aiProgressValue}%` : '-'}
                  </p>
                  <div></div>
                </div>
              </div>
              <div></div>
            </div>
          )}
        </div>
        {(compareDate !== 0 ||
          getOrganicSearchTrafficDetails?.compareStartDate !== 0) && (
          <div
            style={{
              textAlign: 'center',
              ...pdfContainerSx?.compareDateBoxSx,
              marginTop: '14px'
            }}
          >
            <p style={pdfContainerSx?.compareDateTextSx}>
              {timeConverter(
                parseAsLocalDate(getOrganicSearchTrafficDetails?.compareStartDate).getTime(),
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}
              {' - '}
              {` ${timeConverter(
                parseAsLocalDate(getOrganicSearchTrafficDetails?.compareEndDate).getTime(),
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}`}
              {compareDate !== 0 &&
                getOrganicSearchTrafficDetails?.compareEndDate &&
                getOrganicSearchTrafficDetails?.compareStartDate &&
                getGscGraphDetails?.previousStart &&
                getGscGraphDetails?.previousEnd &&
                ` vs previous period (${timeConverter(
                  parseAsLocalDate(getGscGraphDetails?.previousStart).getTime(),
                  userDetails?.date_format ||
                    reportMetaData?.dateFormat ||
                    'DD/MM/YYYY',
                  true,
                  true
                )} - ${timeConverter(
                  parseAsLocalDate(getGscGraphDetails?.previousEnd).getTime(),
                  userDetails?.date_format ||
                    reportMetaData?.dateFormat ||
                    'DD/MM/YYYY',
                  true,
                  true
                )})`}
            </p>
          </div>
        )}
      </Box>
    </>
  );
};
